import { CONTENT_TYPES } from '@hivebrite/design-system/ContentList';

export const AVAILABLE_CONTENT_TYPES = {
  NEWS: CONTENT_TYPES.NEWS,
  USER_EVENT: 'user_event',
  NETWORK_EVENT: 'network_event',
  FORUM: CONTENT_TYPES.FORUM,
} as const;
